import { render } from "./PostsView.vue?vue&type=template&id=d6aa3304&scoped=true&ts=true"
import script from "./PostsView.vue?vue&type=script&lang=ts"
export * from "./PostsView.vue?vue&type=script&lang=ts"

import "./PostsView.vue?vue&type=style&index=0&id=d6aa3304&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\miauerka\\web-projects\\mimafi-project\\mimawebapp\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d6aa3304"]])

export default __exports__